import { Controller } from "stimulus"
import { current, toSentence } from "../helpers"

export default class extends Controller {
  static targets = ["tooltip"]

  initialize() {
    this.updateTooltipTitles()
  }

  // Private

  updateTooltipTitles() {
    for (const target of this.tooltipTargets) {
      const users = JSON.parse(target.getAttribute("data-users"))
      const names = users.map((user, index) => (user.id == current.user.id ? (index ? "you" : "You") : user.first_name))
      target.title = toSentence(names)
    }
  }
}
